export const SET_TOKEN = 'SET_TOKEN'
export const RESET_LOGIN = 'RESET_LOGIN'
export const SET_PASSTHROUGH = 'SET_PASSTHROUGH'

export const SESSION_TOKEN_NAME = 'auth/token'
export const SESSION_USER_PROFILE = 'auth/profile'



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js